import type { Connector } from 'instantsearch.js';
import { noop } from 'instantsearch.js/es/lib/utils';

import { joinFiltersWithAnd, parseFilters, removeFilter } from 'lib/algolia';

type ConnectorState = {
  name: string;
  filter: string;
};

export const connectFilter: Connector<
  {
    $$type: 'sorare.filters';
    renderState: ConnectorState;
    indexRenderState: Record<string, unknown>;
    indexUiState: Record<string, unknown>;
  },
  { name: string; filter: string }
> = (renderFn: any, unmountFn = noop) => {
  return widgetParams => {
    const { name, filter } = widgetParams;

    return {
      $$type: 'sorare.filters',

      init(initOptions) {
        const { instantSearchInstance } = initOptions;

        renderFn(
          {
            ...this.getWidgetRenderState(initOptions),
            instantSearchInstance,
          },
          true
        );
      },

      render(renderOptions) {
        const { instantSearchInstance } = renderOptions;

        renderFn(
          {
            ...this.getWidgetRenderState(renderOptions),
            instantSearchInstance,
          },
          false
        );
      },

      dispose({ state }) {
        unmountFn();

        state.filters = removeFilter(state.filters, filter);
        return state;
      },

      getRenderState(renderState) {
        return renderState;
      },

      getWidgetRenderState() {
        return {
          name,
          filter,
          widgetParams,
        };
      },

      // route to state
      getWidgetUiState(uiState) {
        return uiState;
      },

      // state to route
      getWidgetSearchParameters(searchParameters) {
        const filters = parseFilters(searchParameters.filters);

        if (!filters.includes(filter)) {
          filters.push(filter);
        }
        filters.sort();

        searchParameters.filters = joinFiltersWithAnd(filters);

        return searchParameters;
      },
    };
  };
};
